import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import SVGIcon from 'components/svg-icon/SVGIcon';
import Tooltip from 'components/Tooltip';

import InfluencerCreatorNetworkListPopover from '../popover/InfluencerCreatorNetworkListPopover';

import { __t, applyTranslations } from 'utils/language';
import { getFormattedPercentageRate } from 'utils/formatters';
import {
  getFormattedFollowersValue,
  getNumFollowers
} from 'utils/influencers';
import { CHANNEL_TYPE_INSTAGRAM, CHANNEL_TYPE_TIKTOK } from 'utils/channels';

import './influencer-creator-network-list-item-metrics.scss';

applyTranslations(require('./influencer-creator-network-list-item-metrics.i18n.json'));

type Props = {
  channel: typeof CHANNEL_TYPE_INSTAGRAM | typeof CHANNEL_TYPE_TIKTOK,
  engagementRate?: number | null,
  followers?: number | null,
  parentInfluencerName?: string,
  channelLink: string
};

const MSG_KEY = 'influencer_creator_network_list_item_metrics';

const InfluencerCreatorNetworkListItemMetrics = (
  {
    channel,
    engagementRate,
    followers,
    channelLink,
    parentInfluencerName
  }: Props
): JSX.Element => {
  const metrics = {
    followers: getFormattedFollowersValue(getNumFollowers(followers || 0)),
    engagementRate: getFormattedPercentageRate(engagementRate)
  };

  return (
    <div className="influencer-creator-network-list-item-metrics">
      <div className="influencer-creator-network-list-item-metrics__metric">
        <div className="influencer-creator-network-list-item-metrics__icon">
          <Tooltip
            message={__t(`${MSG_KEY}.tooltips.open_${channel}`)}
            width="short"
          >
            <SVGIcon
              name={`${channel}-no-customisation`}
              width={16}
              height={16}
              link={channelLink}
              onClick={(event) => { event.stopPropagation(); }}
            />
          </Tooltip>
        </div>
        <div className="influencer-creator-network-list-item-metrics__value">
          <InfluencerCreatorNetworkListPopover
            channel={channel}
            identifier="connection-item__value-popover"
            type="channel"
            metrics={metrics}
            parentInfluencerName={parentInfluencerName}
            triggerComponent={(
              getFormattedFollowersValue(getNumFollowers(followers || 0))
            )}
          />
        </div>
      </div>
      <div className="influencer-creator-network-list-item-metrics__metric">
        <InfluencerCreatorNetworkListPopover
          channel={channel}
          identifier="connection-item__avatar-value-popover"
          type="channel"
          metrics={metrics}
          parentInfluencerName={parentInfluencerName}
          triggerComponent={(
            <React.Fragment>
              <div className="influencer-creator-network-list-item-metrics__icon">
                <SVGDynamicIcon
                  name="rotation-arrows-custom-fg"
                  width={16}
                  height={16}
                  customColor="grey"
                />
              </div>
              <div className="influencer-creator-network-list-item-metrics__value">
                {getFormattedPercentageRate(engagementRate)}
              </div>
            </React.Fragment>
          )}
        />
      </div>
    </div>
  );
};

export default InfluencerCreatorNetworkListItemMetrics;
